/* eslint-disable react-refresh/only-export-components */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, theme, App as AntApp } from 'antd';
import enUS from 'antd/locale/en_US';
import App from './App.tsx';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { initGA, trackPageView } from './utils/analytics';
import './index.css';
import './animations.css';

// Initialize Google Analytics
initGA();
trackPageView(window.location.pathname);

function AppWithTheme() {
  const { theme: currentTheme } = useTheme();
  
  return (
    <ConfigProvider 
      locale={enUS}
      theme={{
        algorithm: currentTheme === 'light' ? theme.defaultAlgorithm : theme.darkAlgorithm,
        token: {
          colorPrimary: currentTheme === 'light' ? '#667eea' : '#58a6ff',
          borderRadius: 12,
          colorBgContainer: currentTheme === 'light' ? 'rgba(255, 255, 255, 0.9)' : 'rgba(15, 23, 42, 0.6)',
        },
      }}
    >
      <AntApp>
        <App />
      </AntApp>
    </ConfigProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AppWithTheme />
    </ThemeProvider>
  </React.StrictMode>
);
